<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Message Template Guide</h3>
      </div>
    </div>
  </div>
</div>

<dl class="row">
  <dt class="col-12"><h4>Macro List in Message Template</h4></dt>
  <dd class="col-12">
    <table id="macroList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
        <thead class="thead-dark">
          <tr>
            <th>No</th>
            <th>Macro</th>
            <th>Description</th>
          </tr>
       </thead>
        <tbody>
          <tr *ngFor="let item of macroList; index as i;" >
            <td>{{i+1}}</td>
            <td>{{item.code}}</td>
            <td class="text-left">{{item.description}}</td>
          </tr>
        </tbody>
    </table>
  </dd>

  <dt class="col-12"><h4>Message URL Rules</h4></dt>
  <dd class="col-12">
    <table id="urlRuleList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
        <thead class="thead-dark">
          <tr>
            <th>No</th>
            <th>Rule</th>
            <th>Description</th>
          </tr>
       </thead>
        <tbody>
          <tr *ngFor="let item of urlRuleList; index as i;" >
            <td>{{i+1}}</td>
            <td class="text-left">{{item.rule}}</td>
            <td class="text-left">{{item.description}}</td>
          </tr>
        </tbody>
    </table>
  </dd>


  <dt class="col-12"><h4>Field Description in ShortCode Message</h4></dt>
  <dd class="col-12">
    <table id="scFieldList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
        <thead class="thead-dark">
          <tr>
            <th>No</th>
            <th>Field</th>
            <th>Description</th>
            <th>How to use</th>
          </tr>
       </thead>
        <tbody>
          <tr *ngFor="let item of scFieldList; index as i;" >
            <td>{{i+1}}</td>
            <td>{{item.field}}</td>
            <td>{{item.description}}</td>
            <td class="text-left">{{item.usage}}</td>
          </tr>
        </tbody>
    </table>
  </dd>

  <dt class="col-12"><h4>Field Description in Keyword Message</h4></dt>
  <dd class="col-12">
    <table id="kwFieldList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
        <thead class="thead-dark">
          <tr>
            <th>No</th>
            <th>Field</th>
            <th>Description</th>
            <th>How to use</th>
          </tr>
       </thead>
        <tbody>
          <tr *ngFor="let item of kwFieldList; index as i;" >
            <td>{{i+1}}</td>
            <td>{{item.field}}</td>
            <td>{{item.description}}</td>
            <td class="text-left">{{item.usage}}</td>
          </tr>
        </tbody>
    </table>
  </dd>

</dl>
